import classNames from 'classnames';
import { useCallback, useMemo } from 'react';
import CurrencyFormat from 'react-currency-format';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { ExpandedRowPrice } from '../../../../../../@types';
import { selectorGetFamilyModalIsOpen } from '../../../../../../reducers/gerenciadorPrecos/datapointExhibitionType';
import {
  ADD_GERENCIADOR_EXPANDED_ROW_OPTION,
  REMOVE_GERENCIADOR_EXPANDED_ROW_OPTION,
  RESET_GERENCIADOR_EXPANDED_ROW,
  SET_GERENCIADOR_EXPANDED_ROW_KEY,
  selectorExpandedRowKey,
} from '../../../../../../reducers/gerenciadorPrecos/expandedRowKey';
import { CompetitivenesIcon } from '../../CompetitivenesIcon';
import { LinkButton } from '../../LinkButton';
import { BaseCell } from '../BaseCell';
import { BaseCellProps } from '../BaseCell/BaseCell';
import styles from './CompetitorPriceOfferCell.module.scss';

const { MainContainer } = BaseCell;

export type CompetitorPriceOfferCellProps = BaseCellProps & {
  offer?: ExpandedRowPrice | null;
};

const CompetitorPriceOfferCell = ({ className, rowData, offer, ...props }: CompetitorPriceOfferCellProps) => {
  const { productsToBePricedId, competitivenessIndicator } = rowData;

  const dispatch = useDispatch();

  const { key, options } = useSelector(selectorExpandedRowKey);

  const isExpanded = useMemo(() => {
    return key === productsToBePricedId && options.includes('OFFERPRICE_COMPETITORS');
  }, [key, options, productsToBePricedId]);

  const handleExpandCompetitorsRow = useCallback(() => {
    if (key !== productsToBePricedId) {
      dispatch(RESET_GERENCIADOR_EXPANDED_ROW());
    }

    if (isExpanded) {
      dispatch(REMOVE_GERENCIADOR_EXPANDED_ROW_OPTION('OFFERPRICE_COMPETITORS'));
      return;
    }

    dispatch(SET_GERENCIADOR_EXPANDED_ROW_KEY(productsToBePricedId));
    dispatch(ADD_GERENCIADOR_EXPANDED_ROW_OPTION('OFFER'));
    dispatch(ADD_GERENCIADOR_EXPANDED_ROW_OPTION('OFFERPRICE_COMPETITORS'));
  }, [dispatch, isExpanded, key, productsToBePricedId]);

  const getFamilyModalIsOpen = useSelector(selectorGetFamilyModalIsOpen);

  return (
    <BaseCell className={classNames(styles.container, className)} rowData={rowData} {...props}>
      <MainContainer>
        {offer?.competitorsPrice ? (
          <CurrencyFormat
            fixedDecimalScale
            decimalScale={2}
            value={offer?.competitorsPrice ?? null}
            displayType="text"
            prefix="R$ "
            decimalSeparator=","
            thousandSeparator="."
          />
        ) : (
          '--'
        )}

        {offer?.competitorsPrice && <CompetitivenesIcon type={competitivenessIndicator || (offer?.competitorsPrice && 'RULE_CPI_AVG') || null} />}
      </MainContainer>
      {!getFamilyModalIsOpen && offer?.competitorsPrice && (
        <div className={styles.competitor}>
          <LinkButton onClick={handleExpandCompetitorsRow}>
            {isExpanded ? (
              <>
                <MdKeyboardArrowUp size={10} />
                <p>Fechar</p>
              </>
            ) : (
              <>
                <MdKeyboardArrowDown size={10} />
                <p>Abrir</p>
              </>
            )}
          </LinkButton>
        </div>
      )}
    </BaseCell>
  );
};

export default CompetitorPriceOfferCell;
